import React from 'react'
import { Box, Flex } from 'rebass'

import { FieldError } from './styledComponents'

type InputWrapperProps = {
  disabled: boolean
  children: React.ReactNode
  id: string
  input: any
  label: string
  placeholder: string
  type: string
  meta: {
    touched: boolean
    error: boolean
  }
  [x: string]: any
}

const InputWrapper = (Component: React.FC) => {
  const Wrapper = ({
    disabled,
    children,
    id,
    input,
    label,
    placeholder,
    type,
    meta: { touched, error },
    ...attrs
  }: InputWrapperProps) => (
    <Flex flexWrap='wrap'>
      <Box width={[1, 1 / 3]} >
        <label htmlFor={id}>{label}</label>
      </Box>
      <Box width={[1, 1 / 2]} >
        <Component
          disabled={disabled}
          error={touched && error}
          id={id}
          { ...input }
          placeholder={placeholder}
          type={type}
          {...attrs}
        >
          {children}
        </Component>
        <FieldError>{touched && error && <span>{error}</span>}</FieldError>
      </Box>
    </Flex>
  )
  return Wrapper
}

export { InputWrapper }
